import { render, staticRenderFns } from "./3_ConfigurarSorteio.vue?vue&type=template&id=7bda8348&"
import script from "./3_ConfigurarSorteio.vue?vue&type=script&lang=js&"
export * from "./3_ConfigurarSorteio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports